import { Search } from 'lucide-react';
import Reveal from '../Reveal';
import { ProjectCard } from './ProjectCard';

const EmptyProjects = ({ reset }) => (
  <div data-testid="projects-empty-state" className="text-center py-24 max-w-md mx-auto">
    <Search size={40} strokeWidth={1.2} className="mx-auto mb-5 text-accent" />
    <p className="text-white/60 text-[15px]">Aramaniza uygun proje bulunamadi.</p>
    <button data-testid="projects-reset-filters-button" type="button" onClick={reset} className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-border text-white/80 text-[12.5px] hover:border-primary/60 hover:text-white transition-colors">Filtreleri temizle</button>
  </div>
);

export const ProjectResults = ({ filtered, filter, reset }) => (
  <>
    <section className="px-6 lg:px-10 mb-6">
      <div className="max-w-[1300px] mx-auto text-center">
        <span data-testid="projects-result-count" aria-live="polite" className="text-[13px] text-muted-foreground">
          <span className="text-accent font-semibold">{filtered.length}</span> proje bulundu
          {filter !== 'Tumu' && <>&nbsp;·&nbsp;<span className="text-white/70">{filter}</span></>}
        </span>
      </div>
    </section>
    <section className="px-6 lg:px-10 pb-24">
      <div className="max-w-[1300px] mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filtered.map((project, index) => <Reveal key={project.slug} delay={(index % 6) * 60} className="h-full"><ProjectCard project={project} /></Reveal>)}
      </div>
      {filtered.length === 0 && <EmptyProjects reset={reset} />}
    </section>
  </>
);